import { Card, Row, Col, Typography, Space, Empty } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faClock,
    faMugHot,
    faArrowLeft,
    faCalendarDay,
} from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import { GET_DAILY_ACTIVITY } from "../../../Queries/Activity";
import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector, } from "react-redux";
import { AntdButton, DatePickerField } from "../../../blueplanitUtils/InputField";
import { setLoader } from "../../../Slices/loaderSlice";
import { handleKeyDown } from "../../../blueplanitUtils/DatePickerAutoformate";
const { Text, Title } = Typography;

const formatTime = (seconds = 0) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    return `${h}h ${m}m`;
};

const ActivityHeader = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const [searchParams, setSearchParams] = useSearchParams();

    const [fromDate, setFromDate] = useState(() => {
        const from = searchParams.get("from");
        return from ? dayjs(from) : dayjs().startOf("month");
    });
    const [toDate, setToDate] = useState(() => {
        const to = searchParams.get("to");
        return to ? dayjs(to) : dayjs().endOf("day");
    });

    const isDevice = location.pathname.includes("/device/");
    const employee = useSelector((state) =>
        state.employee.AllEmployees.find(emp => emp.id === id)
    );

    const userName = employee
        ? `${employee.firstname} ${employee.lastname}`
        : "";

    const { data, loading, error } = useQuery(GET_DAILY_ACTIVITY, {
        variables: {
            from: fromDate.toISOString(), // exact timestamp
            to: toDate.toISOString(),
            ...(isDevice ? { deviceId: id } : { userId: id }),
        },
        fetchPolicy: "network-only",
    });

    useEffect(() => {
        dispatch(setLoader(loading));
    }, [loading]);

    const onDayClick = (day) => {
        navigate(
            `/activity/${isDevice ? "device" : "user"}/${id}/${day.date}`
        );
    };

    const days = data?.dailyActivitySummaries || [];

    return (
        <Card style={{ marginBottom: 16 }}>
            <div style={{ marginBottom: 16 }}>
                <AntdButton
                    type="link"
                    label="Back"
                    icon={<FontAwesomeIcon icon={faArrowLeft} />}
                    onClick={() => navigate(-1)}
                    style={{ padding: 0 }}
                />

                <Title level={3} style={{ margin: "8px 0 0 0" }}>
                    {userName}
                </Title>
            </div>

            <Space style={{ marginBottom: 12 }}>
                <DatePickerField
                    value={fromDate}
                    onChange={(d) => {
                        if (!d) return;
                        const newDate = dayjs(d).startOf('day');
                        setFromDate(newDate);
                        setSearchParams(prev => { prev.set("from", newDate.toISOString()); return prev; }, { replace: true });
                    }}
                    allowClear={false}
                    onKeyDown={handleKeyDown}
                    format={"DD/MM/YYYY"}
                />
                <DatePickerField
                    value={toDate}
                    onChange={(d) => {
                        if (!d) return;
                        const newDate = dayjs(d).endOf('day');
                        setToDate(newDate);
                        setSearchParams(prev => { prev.set("to", newDate.toISOString()); return prev; }, { replace: true });
                    }}
                    allowClear={false}
                    onKeyDown={handleKeyDown}
                    format={"DD/MM/YYYY"}
                />
            </Space>
            {error && (
                <Text type="danger">
                    Failed to load activity data. Please try again.
                </Text>
            )}

            {/* 📭 No Data */}
            {!loading && !error && days.length === 0 && (
                <Empty description="No activity found for selected date range" />
            )}
            {!loading &&
                !error &&
                days.map((day) => (
                    <Card
                        hoverable
                        key={day.date}
                        type="inner"
                        size="small"
                        style={{ marginBottom: 8 }}
                        bodyStyle={{ padding: "8px 12px" }}
                        onClick={() => onDayClick(day)}
                    >
                        <Row gutter={24} align="middle">
                            <Col span={6}>
                                <FontAwesomeIcon icon={faCalendarDay} />{" "}
                                <strong>{dayjs(day.date).format("DD MMM YYYY")}</strong>
                            </Col>
                            <Col span={6} style={{ color: "#389e0d" }}>
                                <FontAwesomeIcon icon={faClock} /> Active:{" "}
                                {formatTime(day.totalActive)}
                            </Col>
                            <Col span={6} style={{ color: "#cf1322" }}>
                                <FontAwesomeIcon icon={faMugHot} /> Idle:{" "}
                                {formatTime(day.totalIdle)}
                            </Col>

                            <Col span={6} style={{ color: "orange" }}>
                                {<FontAwesomeIcon icon={faMugHot} />} Break count:{" "}
                                {day.breakCount}
                            </Col>
                        </Row>
                    </Card>
                ))
            }
        </Card >
    );
};

export default ActivityHeader;